import React from 'react';
var useUxReset = function (rowsData, uxState, clearUxState) {
    var _a = React.useState('|'), previous = _a[0], setPrevious = _a[1];
    React.useEffect(function () {
        var ids = (rowsData || []).map(function (row) { return row.id; }).join('|');
        // clear uxState if listed rows change and uxState is not clear already
        if (ids !== previous) {
            if (clearUxState && ((uxState.checkedRows && Object.keys(uxState.checkedRows).length) || uxState.selectedRow)) {
                clearUxState();
            }
        }
        setPrevious(ids);
    }, [rowsData]); // eslint-disable-line react-hooks/exhaustive-deps
};
export default useUxReset;
